import { ChangeDetectionStrategy, Component, Input, OnInit, TemplateRef } from '@angular/core';
import { filter, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ProjectionService } from './projection.service';
import { ProjectionInstance } from './projector.model';

@Component({
    selector: 'projection-slot',
    template: '<ng-container *ngTemplateOutlet="content$ | async; context: context"></ng-container>',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProjectionComponent implements OnInit {
  @Input() name: string;
  @Input() context: unknown = null;

  content$: Observable<TemplateRef<unknown>>;

  constructor(private projectionService: ProjectionService) {}

  ngOnInit(): void {
    this.content$ = this.projectionService.instances$.pipe(
      filter((instance: ProjectionInstance) => !instance || this.name in instance),
      map((instance: ProjectionInstance) => instance && instance[this.name]),
    );
  }
}
